import React from 'react';
import style from './style';
import i18next from "i18next";
import EAButton from "../../../../../components/common/EAButton";
import EAIcon from "../../../../../components/common/EAIcon";
import {IconButton} from "@mui/material";

const AddedTpInfos = ({ tpList, onEdit, onDelete }) => {
  const { classes } = style();

  return (
    <>
      {tpList && tpList.length ? (
        <div className={classes.itemWrapper}>
          <div className={classes.itemTitle}>
            {i18next.t('context.addTiers.associatedTp')}
          </div>
          <div className={classes.tiersList}>
            {tpList.map((tp) => (<div className={classes.itemRow}>
              <div className={classes.item} key={tp.thirdPartyId}>
                <div className={classes.contextWrapper}>
                  <div className={classes.tpName}>{tp.tpInfos.name}</div>
                  <div className={classes.tpActivity}>
                    {tp.tpInfos.activityLabel}
                  </div>
                </div>
                <EAButton
                    onClick={() =>onEdit(tp.tpInfos)}
                    colorVariant={'secondary'}
                    content={i18next.t('context.modifier')}
                    size={'xs'}
                    customStyle={{
                      marginLeft: 'auto',
                    }}
                />
              </div>
              <IconButton
                  onClick={() =>onDelete(tp.thirdPartyId)}
                  size="small"
                  style={{marginLeft: '11px'}}
              >
                <EAIcon className={classes.deleteIcon} icon={'delete_filled'}/>
              </IconButton>
            </div>))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default AddedTpInfos;
